import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/react-demo.css";
import "assets/css/edge-custom.css";
import "assets/css/edge-pages.css";

// effects
import CursorGlow from "components/Effects/CursorGlow.js";

// pages
import Presentation from "views/Presentation.js";
import AIAgents from "views/edge-pages/AIAgents.js";
import Consulting from "views/edge-pages/Consulting.js";
import OpenSource from "views/edge-pages/OpenSource.js";
import AboutUs from "views/edge-pages/AboutUs.js";
import ContactUs from "views/edge-pages/ContactUs.js";
import ProductsHub from "views/edge-pages/ProductsHub.js";
import ProductPage from "views/edge-pages/ProductPage.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <CursorGlow />
    <BrowserRouter>
      <Routes>
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/ai-agents" element={<AIAgents />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/open-source" element={<OpenSource />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/products" element={<ProductsHub />} />
        <Route path="/products/:appSlug" element={<ProductPage />} />
        <Route path="*" element={<Navigate to="/presentation" replace />} />
      </Routes>
    </BrowserRouter>
  </>
);
